import { getImageProxyUrl } from '@/shared/lib/proxy-url';

function formatBlogStructuredDate(raw: string): string {
  const [year, month, day] = raw.split('.');
  if (!year || !month || !day) return raw;
  return `${year}-${month}-${day}`;
}

export function parseBlogDate(raw: string): Date {
  return new Date(`${formatBlogStructuredDate(raw)}T00:00:00+09:00`);
}

export function getBlogImageUrl(src: string): string {
  return getImageProxyUrl({ src });
}
